/* show password reset form after submission */
if (window.location.hash) {
  var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
  //alert (hash);
  // hash found
  if (hash == 'recover') {
    $('#login').hide();
    $('#recover').show();
  }
}
/* end - show password form after submission */

/*
  Right align dropdowns which might fall out of the screen.
*/
function calculateDropdownsPosition(){
  $('.js-nav-new > ul > li').each(function(){
    var $this = $(this);
    $this.removeClass('right-aligned');

    if (!$this.find('.nav__dropdown').length) {
      return;
    }

    var $dropdown = $this.find('.nav__dropdown');
    var dd_left_position = $dropdown.offset().left;
    var dd_width = $dropdown.find('.shell-small').outerWidth();

    // save the width in data since it might change
    if ( $this.data('ddwidth') == undefined ) {
      $this.data('ddwidth', dd_width);
    }

    dd_width = $this.data('ddwidth');

    var dd_right_position = dd_left_position+dd_width;

    var window_size = $(window).width();

    if ( dd_right_position > window_size) {
      $this.addClass('right-aligned');
    }
  })
}

(function ($) {
  calculateDropdownsPosition();

  $('.header ul[data-level="2"]').each(function () {
    var levelTwo = $(this);

    if (levelTwo.find('ul[data-level="3"]').length > 1) {
      levelTwo.addClass('has-multi-columns');
    }
  });

  var lastScrollTop = 0;

  $(window).scroll(function (event) {
      var scroll_2 = $(window).scrollTop();
      console.log('scroll / '+ scroll_2);
      if (scroll_2 === 0) {
        $('.header-wrapper').add($('.main-wrapper')).addClass('initmenuCero');
      }else{
        $('.header-wrapper').add($('.main-wrapper')).removeClass('initmenuCero');
      }
  });

  $(window)
    .on('scroll', function(event){
      var st = $(this).scrollTop();

      

      if (st >= 100) {
        if (st > lastScrollTop){
          $('.header-wrapper').add($('.main-wrapper')).addClass('is-condensed');
          $('.header-wrapper').add($('.main-wrapper')).removeClass('initmenu');
        } else {
          $('.header-wrapper').add($('.main-wrapper')).removeClass('is-condensed');
          $('.header-wrapper').add($('.main-wrapper')).addClass('initmenu');
        }

        lastScrollTop = st;
      }
    })
    .on('load', function () {
      if ($(window).scrollTop() > 0) {
        $('.header-wrapper').add($('.main-wrapper')).addClass('is-condensed');
      } else {
        $('.header-wrapper').add($('.main-wrapper')).removeClass('is-condensed');
      }
    });

  $(document).on('click', '.js-nav-trigger', function (e) {
    e.preventDefault();

    $(this).toggleClass('is-active');
    $('.nav-mobile').toggleClass('is-active');
  });

  $(document).on('click', '.nav-mobile .menu__item--has-dropdown > a:not(.clicked)', function (e) {
    e.preventDefault();

    var $this = $(this);

    $this
      .addClass('is-active clicked')
      .next()
      .slideToggle()
      .parent()
      .siblings()
      .find('a')
      .removeClass('is-active clicked')
      .next()
      .slideUp();
  });

  $('.js-predictive-search').each(function (index, element) {
    var $this = $(this);
    var $form = $this.closest('form');

    setTimeout(function () {
      $this.attr('readonly', false);
    }, 500);

    $form.on('focusin', function () {
      if ($this.val().length !== 0) {
        // $form.find('.js-search-results').addClass('is-active');
      }
    });

    $form.on('focusout', function () {
      // $form.find('.js-search-results').removeClass('is-active');
    });
  });

  // Fix bug search
  
  
  function showFocusSearch() {
    jQuery('.form-search.form-search--blog input#q-1').focus();
  }  
  function showFocusSearchHeader() {
    jQuery('.header-new .form-search input#q-1').focus();
    jQuery('.form-search.form-search--blog input#q-1').blur();
  }  

  var intervalSearchBlog = '';
  var intervalSearchHeader = '';

  
  
  $('.js-predictive-search-blog').each(function (index, element) {
    var $this = $(this);
    var $form = $this.closest('form');

    setTimeout(function () {
      $this.attr('readonly', false);
    }, 500);

    $form.on('focusin', function () {
      if ($this.val().length !== 0) {
        // $form.find('.js-search-results-blog').addClass('is-active');
      }
    });

    $form.on('focusout', function () {
      // $form.find('.js-search-results-blog').removeClass('is-active');
    });
  });

  $('.js-predictive-search').on('input', function (e) {
    console.log('.js-predictive-search2');
    var $this = $(this);
    console.log($this);
    var searchTerm = e.target.value.toLowerCase();
    var $form = $(this).closest('form');
    var $resultsDropdown = $form.find('.js-search-results');

    $resultsDropdown.removeClass('is-active').empty();

    $.getJSON('/search/suggest.json', {
      q: searchTerm,
      resources: {
        type: 'product,page,article,collection',
        limit: 5,
      },
    }).done(function (response) {
      $resultsDropdown.removeClass('is-active').empty();
      let hiddenCollections = document.querySelector('#hidden-collections');
      var productSuggestions = response.resources.results.products;

      if (hiddenCollections) {
        hiddenCollections = hiddenCollections.innerHTML.split(',');
        var collectionSuggestions = response.resources.results.collections.filter(object => {
          return !hiddenCollections.some(element => object.handle.includes(element.replace('\n', '')));
        });
      } else {
        var collectionSuggestions = response.resources.results.collections;
      }

      var pageSuggestions = response.resources.results.pages;
      var articleSuggestions = response.resources.results.articles;

      var htmlMarkup = '';

      if (productSuggestions.length > 0) {
        htmlMarkup += '<h5>Products</h5><ul>';

        $.each(productSuggestions, function (index, element) {
          var elTitle = element.title
            .toLowerCase()
            .split(searchTerm)
            .join('<mark>' + searchTerm + '</mark>');

          htmlMarkup +=
            '<li><a href="' + element.url + '"><h6>' + elTitle + '</h6><p>' + Shopify.formatMoney(element.price) + '</p></a></li>';
        });

        htmlMarkup += '</ul>';
      }

      if (collectionSuggestions.length > 0) {
        htmlMarkup += '<h5>Categories</h5><ul>';

        $.each(collectionSuggestions, function (index, element) {
          var elTitle = element.title
            .toLowerCase()
            .split(searchTerm)
            .join('<mark>' + searchTerm + '</mark>');

          htmlMarkup += '<li><a href="' + element.url + '"><h6>' + elTitle + '</h6></a></li>';
        });

        htmlMarkup += '</ul>';
      }

      if (pageSuggestions.length > 0) {
        htmlMarkup += '<h5>Pages</h5><ul>';

        $.each(pageSuggestions, function (index, element) {
          var elTitle = element.title
            .toLowerCase()
            .split(searchTerm)
            .join('<mark>' + searchTerm + '</mark>');

          htmlMarkup += '<li><a href="' + element.url + '"><h6>' + elTitle + '</h6></a></li>';
        });

        htmlMarkup += '</ul>';
      }

      if (articleSuggestions.length > 0) {
        htmlMarkup += '<h5>Blog Posts</h5><ul>';

        $.each(articleSuggestions, function (index, element) {
          var elTitle = element.title
            .toLowerCase()
            .split(searchTerm)
            .join('<mark>' + searchTerm + '</mark>');

          htmlMarkup += '<li><a href="' + element.url + '"><h6>' + elTitle + '</h6></a></li>';
        });

        htmlMarkup += '</ul>';
      }

      if (htmlMarkup !== '') {
        setInterval(showFocusSearchHeader, 1000);
        $resultsDropdown.append(htmlMarkup);
        $resultsDropdown.addClass('is-active');
      }
    });
  });

  // jQuery('body').on('click', 'div#fc_frame', function() {
  //   console.log('click chat2');
  //   clearInterval(intervalSearchHeader);
  // });

  $('.js-predictive-search-blog').on('input', function (e) {
    console.log('.js-predictive-search-blog1');
    var $this = $(this);
    var searchTerm = e.target.value.toLowerCase();
    var $form = $(this).closest('form');
    var $resultsDropdown = $form.find('.js-search-results-blog');

    $resultsDropdown.removeClass('is-active').empty();

    $.getJSON('/search/suggest.json', {
      q: searchTerm,
      resources: {
        type: 'article',
        limit: 5,
      },
    }).done(function (response) {
      $resultsDropdown.removeClass('is-active').empty();

      var articleSuggestions = response.resources.results.articles;

      var htmlMarkup = '';

      if (articleSuggestions.length > 0) {
        htmlMarkup += '<h5>Articles</h5><ul>';

        $.each(articleSuggestions, function (index, element) {
          var elTitle = element.title
            .toLowerCase()
            .split(searchTerm)
            .join('<mark>' + searchTerm + '</mark>');

          htmlMarkup += '<li><a href="' + element.url + '"><h6>' + elTitle + '</h6></a></li>';
        });

        htmlMarkup += '</ul>';
      }

      if (htmlMarkup !== '') {
        console.log('htmlMarkup');
        setInterval(showFocusSearch, 1000);
        $resultsDropdown.append(htmlMarkup);
        $resultsDropdown.addClass('is-active');
      }
    });
  });

  $(document).ready(function () {
    // Handle clicks on the document
    $(document).click(function (event) {
        console.log('Click event detected');
        // If clicking outside the blog search input
        if (!$(event.target).is('.form-search.form-search--blog input#q-1')) {
            console.log('Clicked outside blog search input');
            clearInterval(intervalSearchBlog);
            $('.form-search.form-search--blog input#q-1').blur();
            jQuery('.search__dropdown.js-search-results-blog').removeClass('is-active');
        } else {
            // Ensure blog search input remains enabled
            $(".header-new .form-search input#q-1").prop('disabled', false);
            jQuery('.header-new .search__dropdown.js-search-results.is-active').removeClass('is-active');
        }
        // If clicking inside the blog search input
        if ($(event.target).is('.form-search.form-search--blog input#q-1')) {
            setInterval(showFocusSearch, 1000);
        }
    });
    // Handle clicks specifically on header search input
    $(document).click(function (event) {
        if ($(event.target).is('.header-new .form-search input#q-1')) {
            console.log('Clicked inside header search input');
            clearInterval(intervalSearchBlog);
            $(".form-search.form-search--blog input#q-1").prop('disabled', false);
            $(".header-new .form-search input#q-1").prop('disabled', false);
        } else {
            console.log('Clicked outside header search input');
            $(".form-search.form-search--blog input#q-1").prop('disabled', false);
            jQuery('.header-new .search__dropdown.js-search-results.is-active').removeClass('is-active');
        }
    });
    // Handle click on header search input to maintain focus intervals
    jQuery('body').on('click', '.header-new .form-search input#q-1', function () {
        console.log('Header search input clicked');
        intervalSearchBlog = setInterval(showFocusSearch, 10000);
        intervalSearchHeader = setInterval(showFocusSearchHeader, 10000);
    });
    // Handle blur event on header search input
    jQuery('.header-new .form-search input#q-1').on('blur', function () {
        console.log('Header search input lost focus');
        clearInterval(intervalSearchBlog);
        clearInterval(intervalSearchHeader);
        // Ensure the input remains enabled
        setTimeout(() => {
            $(".header-new .form-search input#q-1").prop('disabled', false);
            jQuery('.header-new .search__dropdown.js-search-results.is-active').removeClass('is-active');
        }, 1000);
    });
    // Global safeguard to ensure the search inputs are never disabled
    setInterval(() => {
        $(".header-new .form-search input#q-1").prop('disabled', false);
        $(".form-search.form-search--blog input#q-1").prop('disabled', false);
    }, 1000);
});
  

  $(document).on('click', '#theme-ajax-cart button[type="submit"], #theme-ajax-cart a', function (e) {
    e.preventDefault();
    //HACK: this script is redirecting to the cart on any ajax cart change, which we don't want
    //ex: when clicking on x to close cart, we shouldn't be redirected to the cart page
    if (e.target.closest('button') && e.target.closest('button').getAttribute('aria-label') === 'close') {
      return;
    }
    var $this = $(this);

    if ($this.hasClass('ajax-cart__button')) {
      $this.closest('form').trigger('submit');

      return;
    }

    window.location.href = $this.attr('href');
  });

  $(window).on('load resize orientationchange', function () {
    const $header = $('.header-wrapper');
    const headerHeight = $header.outerHeight();

    $('.main-wrapper').css('margin-top', headerHeight);
    calculateDropdownsPosition();
  });

  $(window).on('load', function () {
    const $window = $(this);

    // Select the node that will be observed for mutations
    const targetNode = document.getElementById('shopify-section-header-megamenu');

    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback = function (mutationsList, observer) {
      // Use traditional 'for loops' for IE 11
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          // $window.trigger('resize');
        } else if (mutation.type === 'attributes') {
        }
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);

    chartModalPopup();
  });

  function stickyNavigation($navigation, $mainContent, activeClass) {
    var lastScrollTop = 0;
    var $win = $(window);
    var currentCondition;

    $win
      .on('scroll', function(event){
        var st = $(this).scrollTop();
        currentCondition = st > lastScrollTop;

        updateStickyNav($navigation, $mainContent, activeClass, currentCondition)

        lastScrollTop = st;
      })
      .on('load', function () {
        currentCondition = $win.scrollTop() > 0;

        updateStickyNav($navigation, $mainContent, activeClass, currentCondition)
      });
  }

  function updateStickyNav($nav, $main, myClass, condition) {
    condition ? $nav.add($main).addClass(myClass) : $nav.add($main).removeClass(myClass)
  }

  function chartModalPopup() {
    // Get the modal
    const modal = document.querySelector('[js-chart-modal="modal"]');
    if(modal) {
      // Get the button that opens the modal
      const btn = document.querySelectorAll('[js-chart-modal="open"]');

      // Get the <span> element that closes the modal
      const span = document.querySelector('[js-chart-modal="close"]');

      // When the user clicks the button, open the modal
      btn.forEach(el => {
        el.onclick = function(event) {
          event.preventDefault();

          modal.style.display = "block";
        }
      })
      // When the user clicks on <span> (x), close the modal
      span.onclick = function() {
        modal.style.display = "none";
      }

      // When the user clicks anywhere outside of the modal, close it
      window.onclick = function(event) {
        if (event.target == modal) {
          modal.style.display = "none";
        }
      }
    }
  }

  $('.newsletter-success').on('click', function() {
    $(this).addClass('hidden');
  });
})(jQuery);



const headerNew = document.querySelector('.header-new');

/**
 * Trigger when banner is added to the page
 *
 * @return {Void}
 */
var observer = new WebKitMutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.addedNodes[0]) {
      if (mutation.addedNodes[0].id === 'smartbar-app') {
        const wrapper = document.querySelector('.smartbar-wrapper');

        const smartbarObserver = new WebKitMutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.addedNodes[0]) {
              if (mutation.addedNodes[0].className === 'smartbar-barlist') {
                const barlist = document.querySelector('.smartbar-barlist');
                const bar = barlist.querySelector('.smartbar-bar');
                const close = document.querySelector('.smartbar-bar__close');
                const headerTopGap = bar.offsetHeight;
                headerNew.classList.add('banner-active');

                /**
                 * Update header
                 *
                 * @return {Void}
                 */
                const updateHeader = () => {
                  if (window.scrollY < headerTopGap) {
                    const gap = headerTopGap - window.scrollY;
                    headerNew.style.top = gap + 'px';
                  } else {
                    headerNew.style.removeProperty('top');
                  }
                }

                // updateHeader();

                window.addEventListener('scroll', (event) => {
                  if (headerNew.classList.contains('banner-active')) {
                    updateHeader()
                  }
                });

                /**
                 * Close trigger
                 *
                 * @return {Void}
                 */
                function closeTrigger() {
                  headerNew.style.removeProperty('top');
                  headerNew.classList.remove('banner-active');
                }

                close.addEventListener('click', closeTrigger);
              }
            }
          })
        })

        smartbarObserver.observe(wrapper, {
          childList: true
        });
      }
    }
  })
});

const body = document.querySelector('body');

observer.observe(body, {
    childList: true
});



// Script for wholesale
jQuery('document').ready(function(){   

    
    function updatePrice() {
      if (jQuery(".product_form").hasClass("wholesaleb2b")) {
        var priceMax =  $('div#shopify-section-product .wholesaleb2b .whspriced span').text();
        console.log('ENCONTRO CLASS');
        console.log(priceMax);
        jQuery('.product__information p.modal_price.subtitle.limoniapps-discountninja-productprice span.current_price').removeAttr('data-price-mutation-watcher');
        jQuery('.product__information p.modal_price.subtitle.limoniapps-discountninja-productprice span.current_price>span').removeClass('recharge-inner-most-price');
        jQuery('.product__information p.modal_price.subtitle.limoniapps-discountninja-productprice span.current_price>span').text(priceMax);
      }   
    }    
    const intervalupdatePrice = setInterval(updatePrice, 1);
    updatePrice();
  
    setTimeout(function() { 
        let priceRetail = jQuery('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded  span.was-price>span, div#shopify-section-product span.was-price>span').text();
        var priceRetailDefault =  $('div#shopify-section-product .rtlpricedDefault').data('pricedevm');
        
        jQuery('div#shopify-section-product .rtlpricedDefault span').text(function() {let price = priceRetailDefault; return price % 1 === 0 ? '$' + price : '$' + price.toFixed(2);});
    
        
        
        if(priceRetail != ''){
          // if(jQuery('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded p.rtlpriced, div#shopify-section-product p.rtlpriced').length){
          //   jQuery('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded p.rtlpriced>span, div#shopify-section-product  p.rtlpriced>span').text(priceRetail);
          // }  
          if(jQuery('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded p.rtlpriced').length){
            jQuery('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded p.rtlpriced>span').text(priceRetail);
          }  
        }              
    }, 2000);  
  
    

   setTimeout(function() { 
     clearInterval(intervalupdatePrice);
   }, 25000);
});

$('span.quick_shop.button.action_button').on('click', function(){ 
  console.log('CLICK QUICK SHOP');
  setTimeout(function() { 
        let priceRetail = jQuery('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded  span.was-price>span, div#shopify-section-product span.was-price>span').text();
        if(priceRetail != ''){
          if(jQuery('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded p.rtlpriced, div#shopify-section-product p.rtlpriced').length){
            jQuery('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded p.rtlpriced>span, div#shopify-section-product  p.rtlpriced>span').text(priceRetail);
          }  
        }              
    }, 3000);  
})


$(document).on('change', '.single-option-selector', function() { 
    const intervalupdatePrice = setInterval(updatePrice, 1);
    function updatePrice() {
      if (jQuery(".product_form").hasClass("wholesaleb2b")) {
        var priceMax =  $('div#shopify-section-product .wholesaleb2b .whspriced span').text();
        console.log('ENCONTRO CLASS');
        console.log(priceMax);
        jQuery('.product__information p.modal_price.subtitle.limoniapps-discountninja-productprice span.current_price').removeAttr('data-price-mutation-watcher');
        
        jQuery('.product__information p.modal_price.subtitle.limoniapps-discountninja-productprice span.current_price>span').removeClass('recharge-inner-most-price');


        
        jQuery('.product__information p.modal_price.subtitle.limoniapps-discountninja-productprice span.current_price>span').text(priceMax);
        
        jQuery('.product__information p.modal_price.subtitle.limoniapps-discountninja-productprice span.current_price.recharge-inner-most-price').text(priceMax);
        jQuery('.product__information p.modal_price.subtitle.limoniapps-discountninja-productprice').removeAttr('data-price-mutation-watcher');
      }   
    }  
    updatePrice();
    setTimeout(function() { 
     clearInterval(intervalupdatePrice);
    }, 25000);
  
    const value = $(this).val();
    var term = "collections";
    var handleUrl = window.location.pathname;
    console.log(handleUrl);
    var incStr = handleUrl.includes(term);
  
    if(incStr){
      console.log('ENCONTRO COLLECTION');
      var handleUrl = jQuery('h3.quick-shop__title.js-product-title>a').attr('href');
      setTimeout(function() { 
        const $selectorVariant = $('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded [data-variant-selector]').find('option:contains(' + value + ')');
        var valueSelect = $selectorVariant.val();

        console.log(window.location);
        var rulesVariants = '';
    
       // jQuery('.product-form-container .control.quantity-input-control input.quantity-input.quantity-element.input').val('0');
      
        $.ajax({
          url: ''+handleUrl+'.json',
          type: 'GET',
          dataType: 'json',
          success: function(data) {
            console.log(data);
            // if(data.product){
              let variantsProduct = data.product.variants
              console.log(data.product.variants); // Datos del producto
              for (let index = 0; index < variantsProduct.length; index++) {
                var rulesVariants = variantsProduct[index].quantity_rule.min;
                var retailPrice = variantsProduct[index].compare_at_price;
                var wholePrice = variantsProduct[index].price;
                var idVariants = variantsProduct[index].id;
                if(idVariants == valueSelect){
                  $('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded span.quantityRulesMin, div#shopify-section-product span.quantityRulesMin').text(rulesVariants); 
                   $('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded p.rtlpriced>span, div#shopify-section-product p.rtlpriced>span').text('$'+retailPrice);
                   $('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded p.whspriced>span, div#shopify-section-product p.whspriced>span').text('$'+wholePrice);
                }          
              }
            // }
            
          },
          error: function(error) {
            console.log('Error:', error);
          }
        });
      }, 1500);
    }else{
      const $selectorVariant = $('[data-variant-selector]').find('option:contains(' + value + ')');
      var valueSelect = $selectorVariant.val();

      console.log(window.location);
      var rulesVariants = '';
  
     // jQuery('.product-form-container .control.quantity-input-control input.quantity-input.quantity-element.input').val('0');
    
      $.ajax({
        url: ''+handleUrl+'.json?fields=id,title,variants,metafields',
        type: 'GET',
        dataType: 'json',
        success: function(data) {
          console.log(data);
          // if(data.product){
            let variantsProduct = data.product.variants

            console.log(data); // Datos del producto
            console.log(data.product.variants); // Datos del producto
            for (let index = 0; index < variantsProduct.length; index++) {
              console.log('METAFIELDS'+variantsProduct[index].metafields);
              var rulesVariants = variantsProduct[index].quantity_rule.min;
              var retailPrice = variantsProduct[index].compare_at_price;
              var wholePrice = variantsProduct[index].price;
              var idVariants = variantsProduct[index].id;
              var metafieldValue = variantsProduct[index].metafields && variantsProduct[index].metafields.custom && variantsProduct[index].metafields.custom.retail_price_variant_c;

             
              $('div#shopify-section-product p.rtlpriced2').each(function(){
                 var dataidVariant =  $(this).data('idvm');
                 var dataPriceVariant =  $(this).data('pricevm');
                 if(dataidVariant == idVariants){
                   console.log('IDVARIAN / '+dataidVariant);
                   $(this).find('span').text('$'+dataPriceVariant);
                 }                  
              });
              
              if(idVariants == valueSelect){
                 var dataPriceVariantC =  $('div#shopify-section-product p.rtlpriced2[data-idvm="'+idVariants+'"]').data('pricevm');
                 $('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded span.quantityRulesMin, div#shopify-section-product span.quantityRulesMin').text(rulesVariants); 
                 // $('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded p.rtlpriced>span, div#shopify-section-product p.rtlpriced>span').text('$'+retailPrice);
                 $('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded p.rtlpriced>span').text('$'+retailPrice);
                 $('div#shopify-section-product p.rtlpriced>span').text(function() {
    let price = parseFloat(dataPriceVariantC); 
    return '$' + price.toFixed(2); 
});

                 // $('div#shopify-section-product p.rtlpriced>span').fadeIn();
                 $('.js-quick-shop.quick-shop__popup.fancybox-content.content-loaded p.whspriced>span, div#shopify-section-product p.whspriced>span').text('$'+wholePrice);
              }          
            }
          // }
          
        },
        error: function(error) {
          console.log('Error:', error);
        }
      });
    }
    
    
  
    setTimeout(function() { 
      // let priceCurrent = $('span.current_price>span').text();
      // if($('p.rtlpriced').length){
      //   $('p.whspriced>span').text('$'+wholePrice);
      // }  
       // $('p.whspriced>span').text('$'+wholePrice);
    }, 2000);
})


// Change product slider on variant change
let init_c = 0;
$(document).on('change', '.single-option-selector', function() {    
    console.log('CHANGE');
    const value = $(this).val();
    const $selectorVariant = $('[data-variant-selector]').find('option:contains(' + value + ')');
  
    // if ($selectorVariant && !$('.js-product-sliders').length) {
    if ($selectorVariant && $('body.product .js-product-sliders').length) {
      console.log('here 01');
      const imageId = $selectorVariant.data('media-id');
      console.log(imageId);
  
      if (imageId) {
        // const variantImageSlide = $('.product-gallery .product-gallery__main .flickity-slider').find('.product-gallery__image[data-image-media-id="' + imageId + '"]');
        const variantImageSlide = $('.product-gallery .product-gallery__main').find('.product-gallery__image[data-image-media-id="' + imageId + '"]');
  
        if (variantImageSlide) {
          const index = variantImageSlide.data('index');
          console.log(index);
          if( init_c != 0){
            $('.product-gallery .product-gallery__main').slick( "slickGoTo", [index]);
           // $('.product-gallery .product-gallery__main').trigger( "slideNow", [index]);
          }else{
            init_c = 1 ;
          }
          
        }
      }
  
      return;
    }
  
    if ($selectorVariant && !$('body.collection .js-product-sliders').length) {
      console.log('here 02');
      const imageId = $selectorVariant.data('media-id');
      console.log(imageId);
  
      if (imageId) {
        const variantImageSlide = $('.product-gallery .product-gallery__main .flickity-slider').find('.product-gallery__image[data-image-media-id="' + imageId + '"]');
        // const variantImageSlide = $('.product-gallery .product-gallery__main').find('.product-gallery__image[data-image-media-id="' + imageId + '"]');
  
        if (variantImageSlide) {
          const index = variantImageSlide.data('index');
          
          // $('.product-gallery .product-gallery__main').slick( "slickGoTo", [index]);
           $('.product-gallery .product-gallery__main').trigger( "slideNow", [index]);
        }
      }
  
      return;
    }
  
    if($('.has-filter-images').length){
      productSlidersFiltering()
    } else if($selectorVariant) {
      const imageId = $selectorVariant.data('media-id');
  
      if (imageId) {
        const variantImageSlide = $('.js-product-sliders-main').find('.product-gallery__image[data-image-media-id="' + imageId + '"]');
        const slideIndex = variantImageSlide.parents('.slick-slide').data('slick-index')
  
        if(variantImageSlide){
          slickObj = $('.js-product-sliders-main').slick('getSlick')
  
          slickObj.slickGoTo(slideIndex, true)
        }
      }
    }
})





function productSlidersFiltering(){
  let sku = findSku().toString()
  let hasFiltering = checkProductImages(sku)

  startImageFiltering('.js-product-sliders', hasFiltering, sku)
}

function findSku(){
  const $mainSelector = $('[data-variant-selector]');
  const selectedVariantVal = $mainSelector.val()
  const $selectedOption = $mainSelector.find(`option[value="${selectedVariantVal}"]`);

  return $selectedOption.data('sku')
}

function checkProductImages(sku){
  const $slider = $('.js-product-sliders-main')

  if(sku && $slider){
    const imagesAlts = window.mediaData[0].split(',').filter(Boolean)

    return imagesAlts.some(imageAlt => {
      const slideAltText = imageAlt.split('|')

      return slideAltText.indexOf(sku) > -1
    })
  } else {
    return false
  }
}

function startImageFiltering(className, hasFilterVariants, sku){
  const productSliders = $(className)

  productSliders.slick('slickUnfilter')

  if (hasFilterVariants) {
    const activeVariantFilter = `filter-${sku}`

    addFilterClasses(productSliders, sku)
    filterImages(productSliders, activeVariantFilter)
  }
}

function addFilterClasses (productSliders, sku) {
  productSliders.find('.js-product-slide').each(function () {
    const $this = $(this)
    const filterVariant = $this.data('filter-variant')
    const slideClassList = $this.parents('.slick-slide')[0].classList
    const sanitizedClassList = [...slideClassList].filter(x => !x.includes('filter-'))
    $this.parents('.slick-slide')[0].classList = sanitizedClassList.join(' ')

    if (filterVariant.includes('|')) {
      const sanitizedArr = filterVariant.split('|')
      const skuIndex = sanitizedArr.indexOf(sku)

      if (skuIndex > -1) {
        $this.parents('.slick-slide').addClass(`filter-${sku}`)
      }
    }
  })
}

function filterImages (productSliders, activeVariantFilter) {
  productSliders.slick('slickFilter', function () {
    return $(this).attr('class') === activeVariantFilter
  })

  reIndexSlides(productSliders)
}

function reIndexSlides ($slick) {
  $slick.each(function() {
    const slides = $(this).find('.slick-slide:not(.slick-cloned)')

    slides.each(function (index, slide) {
      $(slide).attr('data-slick-index', index)
    })
  })

  $slick.slick('slickGoTo', 0, true)
}

$('.js-product-slide-thumb').on('click', function(){
  const parent = $(this).parents('.slick-slide');

  index = parent.data('slick-index')
  slickObj = $('.js-product-sliders-main').slick('getSlick')

  slickObj.slickGoTo(index, true)
})

function initializeSliders (sliderClass1, sliderClass2) {
  const slider1 = $(sliderClass1)
  const slider2 = $(sliderClass2)

  slider1.find('img').wrap('<span class="zoom-container"></span>').css('display', 'block').parent().zoom({
    touch: false,
    magnify: 1
  });

  slider1.slick({
    initialSlide: 0,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: slider2,
    infinite: true,
    adaptiveHeight: true
  })

  slider2.slick({
    asNavFor: slider1,
    slidesToShow: 5,
    slidesToScroll: 1,
    focusOnSelect: true,
    infinite: false
  })
}

initializeSliders('.js-product-sliders-main', '.js-product-sliders-thumbnails')

window.addEventListener('DOMContentLoaded', (event) => {
  const loginCheckoutInput = document.querySelector('.js-checkout-primary-login');
  const btnHidden = document.querySelector('.js-hidden-submit-btn')

  if(loginCheckoutInput){
    setTimeout(() => {
      btnHidden.classList.remove('hidden')
    }, 8000);
  }
});

const $giftMessageFields = $('.js-gift-message-fields');

if ($giftMessageFields) {
  const $successMessage = $giftMessageFields.find('.js-success-message');
  let typingTimer;

  /**
   * Check if all inputs are populated
   *
   * @return {Boolean}
   */
  function checkIfAllInputsArePopulated() {
    let allAreValid = true;

    $giftMessageFields.find('input, textarea').each(function() {
      if (!$(this).val()) {
        allAreValid = false;
      }
    })

    return allAreValid;
  }

  $giftMessageFields.find('input, textarea').each(function() {
    const $this = $(this);

    $this.on('keyup', function() {
      clearTimeout(typingTimer);

      typingTimer = setTimeout(() => {
        if (checkIfAllInputsArePopulated()) {
          $successMessage.addClass('is-active');
          return;
        }

        $successMessage.removeClass('is-active');
      }, 1500);
    })

    $this.on('keydown', function() {
      clearTimeout(typingTimer);
    })
  })
}

// let myinput = document.querySelector('textarea#gift-message');



function removeInvalidChars() {
  var myinput = document.querySelector('textarea#gift-message');
  var output = document.querySelector('textarea#gift-message');
  var str = myinput.value;
  

  str = str.replace(/(?:[\u2700\-\u27bf]|(?:\ud83c[\udde6\-\uddff]){2}|[\ud800\-\udbff][\udc00\-\udfff]|[\u0023\-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70\-\udd71]|\ud83c[\udd7e\-\udd7f]|\ud83c\udd8e|\ud83c[\udd91\-\udd9a]|\ud83c[\udde6\-\uddff]|\ud83c[\ude01\-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32\-\ude3a]|\ud83c[\ude50\-\ude51]|\u203c|\u2049|[\u25aa\-\u25ab]|\u25b6|\u25c0|[\u25fb\-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600\-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9\-\u23f3]|[\u23f8\-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190\-\u21ff]|[\uE000\-\uF8FF]|\uD83C[\uDF00\-\uDFFF]|\uD83D[\uDC00\-\uDDFF])/g, '').replace(/[^A-Za-z0-9\w\.,\?""!@#\$%\^&\*\(\)\-_=\+;:<>\/\\\|\}\{\[\]`~\s\']*/g, '');

  //str = str.replace(/./,"");

  //str = str.replace(/[^\w\.,\?""!@#\$%\^&\*\(\)-_=\+;:<>\/\\\|\}\{\[\]`~\s]*/g,"")
  console.log(str);
  console.log(str.length);

  jQuery(myinput).val(str);

  // myinput.value = str;
}

// jQuery(document).on('change', 'textarea#gift-message', function() {    
//   var myinput = jQuery('.gift_message_toggle.gift_msg_toggled_off textarea#gift-message').val();
//   myinput =  myinput.replace(/(?:[\u2700\-\u27bf]|(?:\ud83c[\udde6\-\uddff]){2}|[\ud800\-\udbff][\udc00\-\udfff]|[\u0023\-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70\-\udd71]|\ud83c[\udd7e\-\udd7f]|\ud83c\udd8e|\ud83c[\udd91\-\udd9a]|\ud83c[\udde6\-\uddff]|\ud83c[\ude01\-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32\-\ude3a]|\ud83c[\ude50\-\ude51]|\u203c|\u2049|[\u25aa\-\u25ab]|\u25b6|\u25c0|[\u25fb\-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600\-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9\-\u23f3]|[\u23f8\-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190\-\u21ff]|[\uE000\-\uF8FF]|\uD83C[\uDF00\-\uDFFF]|\uD83D[\uDC00\-\uDDFF])/g, '').replace(/[^A-Za-z0-9\w\.,\?""!@#\$%\^&\*\(\)\-_=\+;:<>\/\\\|\}\{\[\]`~\s\']*/g, '');
//   jQuery('.gift_message_toggle textarea#gift-message').val(myinput);
//   jQuery('.gift_message_toggle textarea#gift-message').text(myinput);
//   console.log(myinput);
// });




// $(document).ready(function(){
//   $('.gift_message_toggle.gift_msg_toggled_off textarea#gift-message').on('input', function(){
//     var longitudTexto = $(this).val().length;
//     console.log('escribiendo');
//   });
// });

$(document).on('input', '.gift_message_toggle.gift_msg_toggled_off textarea#gift-message', function() {
    var myinput = $(this).val();
    myinput =  myinput.replace(/(?:[\u2700\-\u27bf]|(?:\ud83c[\udde6\-\uddff]){2}|[\ud800\-\udbff][\udc00\-\udfff]|[\u0023\-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70\-\udd71]|\ud83c[\udd7e\-\udd7f]|\ud83c\udd8e|\ud83c[\udd91\-\udd9a]|\ud83c[\udde6\-\uddff]|\ud83c[\ude01\-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32\-\ude3a]|\ud83c[\ude50\-\ude51]|\u203c|\u2049|[\u25aa\-\u25ab]|\u25b6|\u25c0|[\u25fb\-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600\-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9\-\u23f3]|[\u23f8\-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190\-\u21ff]|[\uE000\-\uF8FF]|\uD83C[\uDF00\-\uDFFF]|\uD83D[\uDC00\-\uDDFF])/g, '').replace(/[^A-Za-z0-9\w\.,\?""!@#\$%\^&\*\(\)\-_=\+;:<>\/\\\|\}\{\[\]`~\s\']*/g, '');
    jQuery('.gift_message_toggle textarea#gift-message').val(myinput);
    jQuery('.gift_message_toggle textarea#gift-message').text(myinput);
    console.log(myinput);
});

jQuery(document).on('change', 'input#gift_toggle', function() {      
    
    console.log('M change');
    if ($(this).is(':checked')) {
      
       /**  price product */
       $("div#theme-ajax-cart .ajax-cart__price.price").each(function(index, el) {
          var parent = $(this).parent();
          $(this).clone().appendTo(parent).addClass('isVisible');
          var itemCreate = parent.find('.isVisible');
          console.log(itemCreate);
          itemCreate.removeAttr('data-limoniapps-discountninja-cart-key');
          itemCreate.removeClass('ajax-cart__price price limoniapps-discountninja-cart-item-product-price');
          var recuperdPrice = itemCreate.find('.limoniapps-discountninja-productprice-replaced span.money.limoniapps-discountninja-money.geolizr-currency span.money').text();
         console.log(recuperdPrice);
          if(recuperdPrice != ''){
          	$('div#ajax-cart__content').addClass('custom__class_gp');
          }else{
            $('div#ajax-cart__content').addClass('custom__class_gp custom__class__normal_gp');
            parent.addClass('defaul__price');
          }
          itemCreate.find('span:first-child').text(recuperdPrice );
          itemCreate.find('span:first-child').removeClass('limoniapps-discountninja-cart-item-product-price' );
          itemCreate.find('span:first-child').addClass('recoveryPrice_gp' );
       });

      /**  discount porcent product */
      $("div#theme-ajax-cart .limoniapps-discountninja-cart-item-product-comment").each(function(index, el) {
          var parent = $(this).parent();
          $(this).clone().appendTo(parent).addClass('isVisiblePorcent');
          var itemCreate_p = parent.find('.isVisiblePorcent');
          console.log(itemCreate_p);
          itemCreate_p.removeAttr('data-limoniapps-discountninja-cart-key');
          itemCreate_p.removeClass('limoniapps-discountninja-cart-item-product-comment');
          itemCreate_p.find('div.limoniapps-discountninja-cart-item-product-comment').removeClass('limoniapps-discountninja-cart-item-product-comment').addClass('isVisiblePorcentContent');
          itemCreate_p.find('span.limoniapps-discountninja-productprice-replaced').removeClass('limoniapps-discountninja-productprice-replaced').addClass('isVisiblePorcentContentSpan');
     });

      /**  subtotal products */
      $("#theme-ajax-cart span.money.limoniapps-discountninja-cart-subtotal-price").each(function(index, el) {
          var parent = $(this).parent();
          $(this).clone().appendTo(parent).addClass('isVisibleSubtotal');
          $('.isVisibleSubtotal').removeClass('money limoniapps-discountninja-cart-subtotal-price');
          $('.isVisibleSubtotal').find('*').removeAttr('class');
      });
      
     $(document).on('click','span.quantity-plus.quantity-element, span.quantity-minus.quantity-element, button.close',function(){
         console.log('CLICK PLUS3');
         setTimeout(function() {
           /**  price product */
           $("div#theme-ajax-cart .ajax-cart__price.price").each(function(index, el) {
              var parent = $(this).parent();
              $(this).clone().appendTo(parent).addClass('isVisible');
              var itemCreate = parent.find('.isVisible');
              console.log(itemCreate);
              itemCreate.removeAttr('data-limoniapps-discountninja-cart-key');
              itemCreate.removeClass('ajax-cart__price price limoniapps-discountninja-cart-item-product-price');
              var recuperdPrice = itemCreate.find('.limoniapps-discountninja-productprice-replaced span.money.limoniapps-discountninja-money.geolizr-currency span.money').text();
              if(recuperdPrice != ''){
              	$('div#ajax-cart__content').addClass('custom__class_gp');
              }else{
                $('div#ajax-cart__content').addClass('custom__class_gp custom__class__normal_gp');
                parent.addClass('defaul__price');
              }
              itemCreate.find('span:first-child').text(recuperdPrice );
              itemCreate.find('span:first-child').removeClass('limoniapps-discountninja-cart-item-product-price' );
              itemCreate.find('span:first-child').addClass('recoveryPrice_gp' );
           });

           /**  discount porcent product */
            $("div#theme-ajax-cart .limoniapps-discountninja-cart-item-product-comment").each(function(index, el) {
                var parent = $(this).parent();
                $(this).clone().appendTo(parent).addClass('isVisiblePorcent');
                var itemCreate_p = parent.find('.isVisiblePorcent');
                console.log(itemCreate_p);
                itemCreate_p.removeAttr('data-limoniapps-discountninja-cart-key');
                itemCreate_p.removeClass('limoniapps-discountninja-cart-item-product-comment');
                itemCreate_p.find('div.limoniapps-discountninja-cart-item-product-comment').removeClass('limoniapps-discountninja-cart-item-product-comment').addClass('isVisiblePorcentContent');
                itemCreate_p.find('span.limoniapps-discountninja-productprice-replaced').removeClass('limoniapps-discountninja-productprice-replaced').addClass('isVisiblePorcentContentSpan');
           });

            /**  subtotal products */
            $("#theme-ajax-cart span.money.limoniapps-discountninja-cart-subtotal-price").each(function(index, el) {
                $('.isVisibleSubtotal').remove();
                var parent = $(this).parent();
                $(this).clone().appendTo(parent).addClass('isVisibleSubtotal');
                $('.isVisibleSubtotal').removeClass('money limoniapps-discountninja-cart-subtotal-price');
                $('.isVisibleSubtotal').find('*').removeAttr('class');
                
            });            
         }, 3000);
     });   
      
    }
});



// custom ajax cart bar
let element_exist = 0;
let intervquery = null;

function formatPrice(priceInCents) {
  let price = priceInCents / 100;
  return price.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  });
}

let loop_init = 0;
$(document).on('click', '.ajax-submit, span.quantity-plus.quantity-element, span.quantity-minus.quantity-element, button.close, li.menu__item-cart>a', function (e) {  
  loop_init = 0;
  jQuery('div#theme-ajax-cart form.ajax-cart__form .ajax-cart__subtotal.ajax-cart__details-row.is-flex.is-justify-space-between').removeClass('removeblockhidden');
  intervquery = setInterval(queryCart, 1000);
});

$(document).on('change', 'div#theme-ajax-cart input.quantity-input.quantity-element.input', function (e) {  
  loop_init = 0;
  jQuery('div#theme-ajax-cart form.ajax-cart__form .ajax-cart__subtotal.ajax-cart__details-row.is-flex.is-justify-space-between').removeClass('removeblockhidden');
  intervquery = setInterval(queryCart, 1000);
});


function queryCart() {
  if(loop_init <= 6) {
    loop_init++;    
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(cart) {
        console.log('El carrito tiene ' + cart.item_count + ' artículos.');
        console.log(cart);
        let originalPrice = cart.original_total_price;
        let priceWithDiscount = cart.total_price;
        let discount = cart.total_discount;
        let formattedPriceDiscount = formatPrice(priceWithDiscount); 
        let formattedPriceOriginal = formatPrice(originalPrice); 

        if(discount != 0){
          if(element_exist === 0){
            jQuery('div#theme-ajax-cart form.ajax-cart__form .ajax-cart__subtotal.ajax-cart__details-row .ajax-cart__row-description').after('<div class="subtotal_custom_limpn subtotal_custom_limpn_discount"><span class="discount_custom_limpn">'+formattedPriceDiscount+'</span><span class="original_custom_limpn">'+formattedPriceOriginal+'</span></div>');
            element_exist = 1;
          }else{   
            jQuery('.subtotal_custom_limpn').addClass('subtotal_custom_limpn_discount');
            jQuery('.discount_custom_limpn').text(formattedPriceDiscount);
            jQuery('.original_custom_limpn').text(formattedPriceOriginal);
          }  
          jQuery('div#theme-ajax-cart form.ajax-cart__form .ajax-cart__subtotal.ajax-cart__details-row.is-flex.is-justify-space-between').addClass('removeblockhidden');
          clearInterval(intervquery);
        }else{
          console.log('no descuento');
          if(element_exist === 0){
            jQuery('div#theme-ajax-cart form.ajax-cart__form .ajax-cart__subtotal.ajax-cart__details-row .ajax-cart__row-description').after('<div class="subtotal_custom_limpn"><span class="discount_custom_limpn"></span><span class="original_custom_limpn">'+formattedPriceOriginal+'</span></div>');
            element_exist = 1;
          }else{            
            jQuery('.original_custom_limpn').text(formattedPriceOriginal);
          } 
          jQuery('.subtotal_custom_limpn_discount').removeClass('subtotal_custom_limpn_discount');
        }        
      },
      error: function() {
        console.log('No se pudo recuperar el carrito.');
      }
    });
  } else {
        jQuery('div#theme-ajax-cart form.ajax-cart__form .ajax-cart__subtotal.ajax-cart__details-row.is-flex.is-justify-space-between').addClass('removeblockhidden');
        clearInterval(intervquery);
   }
}




// $(document).on('click','span.quantity-plus.quantity-element, span.quantity-minus.quantity-element, button.close',function(){
//   setInterval(function () {
//     let valueprice = 0;
//     $("body> #theme-ajax-cart .ajax-cart__product.media").each(function(index, el) {
//           var _this = $(this);
//           let price = _this.find('.ajax-cart__price.price span');
//           let value_this = price.text();

//           let originalPriceString = value_this;
//           let priceWithoutDollarSign = originalPriceString.replace("$", "");
//           let priceWithoutDot = priceWithoutDollarSign.replace(".", "");
//           let priceAsNumber = parseInt(priceWithoutDot, 10);

//           valueprice = valueprice + priceAsNumber;

//           let subtotalPrice = valueprice; // El precio en centavos
//           let formattedPrice = (subtotalPrice / 100).toFixed(2); // Convertir a unidades de moneda y fijar dos decimales

          
//           console.log(priceAsNumber); // Debería imprimir 38500
//           console.log(formattedPrice);
//           jQuery('.ajax-cart__subtotal.ajax-cart__details-row > span').text('$'+formattedPrice);
//       });
//   }, 2000);
// });




// Fix: Recharge dynamically re-renders product pricing and can cause incorrect prices,
// especially during rapid variant changes or on single-variant products.
// This solution uses the selected variant ID + product JSON as the source of truth,
// ensuring the correct price is always displayed without flicker or race conditions.

jQuery(document).ready(function(){

  let productDataPromise = null;
  let latestVariantId = null;

  function getProductJson() {
    if (!productDataPromise) {
      productDataPromise = fetch(window.location.pathname + '.js', {
        credentials: 'same-origin'
      }).then(function(res) {
        if (!res.ok) throw new Error('Failed to load product JSON');
        return res.json();
      });
    }
    return productDataPromise;
  }

  function getSelectedVariantId(product) {
    // Standard Shopify variant selector
    const mainSelector = document.querySelector('[data-variant-selector]');
    if (mainSelector && mainSelector.value) {
      return String(mainSelector.value);
    }

    // Fallback for single-variant products
    if (product && product.variants && product.variants.length === 1) {
      return String(product.variants[0].id);
    }

    return null;
  }

  function formatPriceFromCents(cents) {
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function setDisplayedPrice(priceText) {
    const selectors = [
      'span.current_price.recharge-inner-most-price',
      'span.current_price.js-current-price'
    ];

    selectors.forEach(function(selector) {
      document.querySelectorAll(selector).forEach(function(el) {
        if (el.textContent.trim() !== priceText) {
          el.textContent = priceText;
          el.setAttribute('data-wholesale-forced', 'true');
        }
      });
    });
  }

  function syncWholesalePrice() {
    if (!jQuery('.product_form').hasClass('wholesaleb2b')) return;

    getProductJson().then(function(product) {

      const variantId = getSelectedVariantId(product);
      if (!variantId) return;

      latestVariantId = variantId;

      const variant = (product.variants || []).find(function(v) {
        return String(v.id) === String(latestVariantId);
      });

      if (!variant) return;

      const wholesalePrice = formatPriceFromCents(variant.price);
      setDisplayedPrice(wholesalePrice);

      console.log('SYNC WHOLESALE →', latestVariantId, wholesalePrice);

    }).catch(function(err) {
      console.log('Wholesale sync error:', err);
    });
  }

  // Initial run
  syncWholesalePrice();

  // Variant changes
  $(document).on('change', '.single-option-selector, [data-variant-selector]', function() {
    syncWholesalePrice();
  });

  // Watch for Recharge re-rendering price
  const target = document.querySelector('.product__information');
  if (target) {
    const observer = new MutationObserver(function(mutations) {

      const touchedPrice = mutations.some(function(mutation) {
        return jQuery(mutation.target).closest('.current_price').length > 0;
      });

      if (touchedPrice) {
        syncWholesalePrice();
      }

    });

    observer.observe(target, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

});